export const REQUEST_SEARCH_PLACES = "places/REQUEST_SEARCH_PLACES";
export const REQUEST_SEARCH_PLACES_SUCCESS = "places/REQUEST_SEARCH_PLACES_SUCCESS";
export const REQUEST_SEARCH_PLACES_FAIL = "places/REQUEST_SEARCH_PLACES_FAIL";
export const REQUEST_SEARCH_PLACES_RESET = "places/REQUEST_SEARCH_PLACES_RESET";
